import MainPageMobile from "./MainPageMobile";

function MyTaskMain() {
  return <MainPageMobile />;
}

export default MyTaskMain;
